import {HttpClient, HttpStatusCode} from 'data/protocols/http';

import {APIError} from 'data/errors/api-error';
import {SignUpSendToken, SignUpSendTokenModel, SignUpSendTokenParams} from 'domain/usecases';

export class RemoteSignUpSendToken implements SignUpSendToken {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<SignUpSendTokenModel>,
	) {}

	async signUpSendToken({
		signal,
		...bodyParams
	}: SignUpSendTokenParams): Promise<SignUpSendTokenModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'post',
			body: bodyParams,
			signal,
		});
		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
